'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSystemUpdateAlt = function MdSystemUpdateAlt(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 5.9q1.3 0 2.3 0.9t1.1 2.3v23.4q0 1.3-1.1 2.3t-2.3 1.1h-30q-1.3 0-2.3-1.1t-1.1-2.3v-23.4q0-1.3 1.1-2.3t2.3-0.9h10v3.2h-10v23.4h30v-23.4h-10v-3.2h10z m-15 21.6l-6.6-6.6h5v-15h3.2v15h5z' })
        )
    );
};

exports.default = MdSystemUpdateAlt;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/system-update-alt.js
// module id = 3601
// module chunks = 0